import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import _cloneDeep from 'lodash/cloneDeep';
import { paymentTypes } from '../../data/payment-types';
import { PRODUCTION_SUBSCRIPTIONS_IDS, STAGING_SUBSCRIPTIONS_IDS } from './CloverPublishModal.constants';

function isPlanValid(plan) {
  return ['Standard', 'Professional'].includes(plan.title);
}

export function getPlans() {
  var validPlans = paymentTypes.filter(function (plan) {
    return isPlanValid(plan);
  }).map(function (plan) {
    return _cloneDeep(plan);
  }); // there is only monthly pricing in clover checkout

  return validPlans.map(function (_ref) {
    var monthly = _ref.monthly,
        rest = _objectWithoutProperties(_ref, ["monthly"]);

    return _objectSpread(_objectSpread({}, rest), {}, {
      monthly: monthly,
      pricing: {
        description: "<span>$".concat(monthly.price, "</span>/ month")
      }
    });
  });
}

function getSubscriptionId(planName) {
  if (process.env.STRIPE_PLAN_MODE === 'production') {
    return PRODUCTION_SUBSCRIPTIONS_IDS[planName];
  }

  return STAGING_SUBSCRIPTIONS_IDS[planName];
}

export function getCloverUrl(planName) {
  // {CLOVER_BASE_APP_MARKET_HOST}/appmarket/apps/{CLOVER_APP_ID}?subscriptionId={SUBSCRIPTION_ID}
  return "".concat(process.env.CLOVER_BASE_APP_MARKET_HOST, "/appmarket/apps/").concat(process.env.CLOVER_APP_ID, "?subscriptionId=").concat(getSubscriptionId(planName));
}